module.exports = __webpack_public_path__ + "img/businesLicese4.aa272273.png";